import type { App, DirectiveBinding } from "vue";
import usePermission from "@/store/modules/permission";
import dayjs from "dayjs";
import useAccount from "@/store/modules/account";
import { ACCOUNT } from "@/global/constant";
import cache from "@/utils/cache";

function registerDirectives(app: App): void {
  // 监听按钮点击指令 并上报行为
  app.directive("trace", {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
      const { page, label } = binding.value;

      el.addEventListener("click", () => {
        if (window.gtag) {
          const account = useAccount();
          const params = {
            page_name: page,
            button_name: label,
            user_name:
              account.userInfo.account || cache.getCache(ACCOUNT)?.account,
            event_date: dayjs().format("YYYY-MM-DD HH:mm:ss")
          };
          console.log("click", params);
          window.gtag("event", "button_click", params);
        }
      });
    }
  });

  app.directive("button", {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
      const permission = usePermission();
      const value = binding.value as string;
      let btn;
      // 延迟按钮接口
      setTimeout(() => {
        if (value) {
          if (value.includes(",")) {
            const [pagePath, btnPath] = value.split(",");
            btn = permission.hasPermissionByPath(pagePath, btnPath);
          } else {
            btn = permission.hasPermission(value);
          }

          if (!btn) {
            return el.parentNode && el.parentNode.removeChild(el);
          }
        } else {
          throw new Error("按钮权限值为空!");
        }
      }, 500);
    }
  });
}
export default registerDirectives;
